import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, json, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import $ from 'jquery';
import { CutTransferDetails } from '../../components/NewOrder';
import moment from 'moment';
import CutTransferModal from '../../components/CutTransferModal';
let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { key: "IdOTRC", title: "Traspaso #", active: true },
    { key: "U_CreateDate", title: "Fecha Registro", active: true },
    { key: "U_UsrOriName", title: "Usuario Origen", active: true },
    { key: "U_UsrDesName", title: "Usuario Destino", active: true },
    { key: "U_ShiftType", title: "Tipo Corte", active: true },
    { key: "U_Status", title: "Estatus", active: true },

    { key: "U_AcceptByName", title: "Aceptado Por", active: true },
    { key: "U_AcceptDate", title: "Fecha Aceptación", active: true },

    { key: "U_UsrOri", title: "Cód. Usuario Origen", active: false },
    { key: "U_UsrDes", title: "Cód. Usuario Destino", active: false },
    { key: "U_AcceptBy", title: "Cód. Aceptado Por", active: false },
    { key: "U_CreateTime", title: "Hora Creación", active: false },
    { key: "U_UpdateDate", title: "Fecha Actualización", active: false },
    { key: "U_UpdateTime", title: "Hora Actualización", active: false },

    { key: "U_Accepted", title: "Aceptado", active: false },
    { key: "U_AcceptTime", title: "Hora Aceptación", active: false },

    { key: "U_CloseDate", title: "Fecha Cierre", active: false },
    { key: "U_CloseTime", title: "Hora Cierre", active: false },
    { key: "U_CloseBy", title: "Cerrado Por", active: false },

    { key: "U_ReassignTo", title: "Reasignado A", active: false },
    { key: "U_ReassignDate", title: "Fecha Reasignación", active: false },
    { key: "U_ReassignTime", title: "Hora Reasignación", active: false },

    { key: "U_Comments", title: "Comentarios", active: false }
];

class CutTransferView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            data: [],
            newOrderModel: {},
            showCutTransferDetailsModal: false,
            action: 'new',
            configHeaderUserFields: [],
            searchData: {
                dateTo: moment().format('YYYY-MM-DD'),
                dateFrom: moment().format('YYYY-MM-DD'),
                IdOTRC: '',
                UsrDes: '',
                Status: '',
                ShiftType: '',
                AcceptBy: '',
            }

        }
    }

    componentDidMount = async () => {
        this.listCutTransfers();
    }
    listCutTransfers = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { _user, searchData } = this.state;

        if (_user?.U_FMB_CounterRol !== "manager") {
            return showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción' })
        }
        const {
            dateFrom,
            dateTo,
            ...rest
        } = searchData || {};

        const data = {
            ...rest,
            IDate: dateFrom,
            FDate: dateTo,
            p_UserId: _user?.pk_UserID,
            operation: 'get'
        };

        enableSpinner(true);
        const listCutTransfers = await apiClient.cutTransferOperation(data);
        enableSpinner(false);

        if (listCutTransfers?.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: listCutTransfers?.data ?? [],
            })
        } else {
            showAlert({ type: 'error', message: listCutTransfers?.message ?? 'Ocurrió un error al obtener los resultados' })
        }
    }

    fillCutTransferModel = (model, data) => {
        let header = data?.header ?? {};
        let operations = data?.body ?? [];

        const { U_UsrOri = '', U_UsrDes = '', U_UsrOriName = '', U_UsrDesName = '', U_ShiftType = '', U_CreateDate = '', U_AcceptDate = '', U_Status = 'P', IdOTRC = '' } = header;
        model.UsrOri = U_UsrOri;
        model.UsrDes = U_UsrDes;
        model.UsrOriName = U_UsrOriName;
        model.UsrDesName = U_UsrDesName;
        model.ShiftType = U_ShiftType;
        model.Status = U_Status;
        model.IdOTRC = IdOTRC;
        model.CreateDate = U_CreateDate ? moment.utc(U_CreateDate).format('DD/MM/YYYY') : '';
        model.AcceptDate = U_AcceptDate ? moment.utc(U_AcceptDate).format('DD/MM/YYYY') : '';
        model.operations = operations;

        return model;
    }

    detailsCutTransfer = async (request) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props

        enableSpinner(true);
        const data = {
            operation: 'getDetails',
            IdOTRC: request?.IdOTRC
        };

        enableSpinner(true);
        const details = await apiClient.cutTransferOperation(data);
        enableSpinner(false);

        if (details?.status === SERVICE_RESPONSE.SUCCESS) {
            let newOrderModel = new CutTransferDetails();
            newOrderModel = this.fillCutTransferModel(newOrderModel, details?.data ?? {});

            this.setState({
                newOrderModel,
                showCutTransferDetailsModal: true,
            }, () => {
                $('#cutTransferModal').modal('show');
            })
        } else {
            showAlert({ type: 'error', message: details.message, timeOut: 8000 })
        }
    }

    refreshModel = newOrderModel => {
        this.setState({
            newOrderModel
        })
    }

    refreshSearch = searchData => {
        this.setState({
            searchData: { ...searchData }
        })
    }

    resetData = (search = true) => {
        $('#cutTransferModal').modal('hide');
        $('#cutTransferUsersModal').modal('hide');
        $('#confirmCutTransferModal').modal('hide');

        setTimeout(() => {
            this.setState((prevState) => ({
                data: search ? [] : prevState.data,
                newOrderModel: {},
                showCutTransferDetailsModal: false,
            }), () => {
                if (search) {
                    this.listCutTransfers();
                }
            });
        }, 500);
    }

    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { _user, data, newOrderModel, showCutTransferDetailsModal, searchData } = this.state
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'TRASPASO DE CORTES'} url1={'#'} />

                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="wareHouseAdmin" className="text-muted">
                            &nbsp;TRASPASO DE CORTES
                        </a>
                    </h2>
                    <DataTables
                        headers={headersDataTable}
                        view={"cutTransfers"}
                        data={data}
                        search={this.listCutTransfers}
                        openDetails={this.detailsCutTransfer}
                        details={newOrderModel}
                        searchData={searchData}
                        refreshSearch={this.refreshSearch}
                    />
                </div>

                {showCutTransferDetailsModal &&
                    <CutTransferModal
                        newOrderModel={newOrderModel}
                        refreshModel={this.refreshModel}
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        cleanData={this.resetData}
                        view={"cutTransfers"}
                        isDetail={true}
                    />
                }

            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CutTransferView);
